import { Plus } from "lucide-react";
import { Button } from "../ui/button";
import { PublicationCard } from "./PublicationCard";
import { isoDate, longDate } from "./calendarUtils";

export const PublicationAgenda = ({ days, posts, onAdd, onEdit, view = "day" }) => (
  <div className={`grid gap-5 ${view === "week" ? "xl:grid-cols-7 xl:gap-2" : ""}`} data-testid={`diffusion-${view}-view`}>
    {days.map(day => {
      const dayPosts = posts.filter(post => post.date === day);
      const today = day === isoDate(new Date());
      return <section key={day} className="min-w-0 border-t border-slate-200 pt-2" data-testid={`diffusion-day-${day}`}>
        <div className="flex items-start gap-2 justify-between mb-2">
          <div className="min-w-0 pt-2"><h2 className={`text-sm font-semibold capitalize break-words ${today ? "text-[#26788A]" : "text-slate-800"}`}>{longDate(day)}</h2><p className="text-xs text-slate-400 mt-1" data-testid={`diffusion-day-count-${day}`}>{today ? "Aujourd’hui · " : ""}{dayPosts.length} publication{dayPosts.length > 1 ? "s" : ""}</p></div>
          <Button variant="ghost" className="h-11 w-11 p-0 shrink-0 text-[#26788A]" onClick={() => onAdd(day)} aria-label={`Ajouter une publication le ${longDate(day)}`} title="Ajouter une publication" data-testid={`diffusion-add-${day}`}><Plus size={18} /></Button>
        </div>
        <div className="space-y-2">{dayPosts.map(post => <PublicationCard key={post.id} post={post} onClick={onEdit} />)}</div>
        {!dayPosts.length && <p className="py-3 text-xs text-slate-400" data-testid={`diffusion-empty-${day}`}>Aucune publication</p>}
      </section>;
    })}
  </div>
);